module.exports = __webpack_public_path__ + "static/media/sawatzky_logo.62f38ede.png";